import React, { useEffect, useRef, useState } from "react";
import "./common.styles.scss";
import {
  Card,
  Col,
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Collapse,
  Tooltip,
} from "reactstrap";
import "./common.styles.scss";
import "react-circular-progressbar/dist/styles.css";
import { Link } from "react-router-dom";
import classnames from "classnames";
import Select from "react-select";
//import images

import bell from "../../assets/images/svg/bell.svg";
import Flatpickr from "react-flatpickr";
import {
  getJobsData,
  getTimeEntryTypeList,
  timeEntryListOpen,
  timeEntryStart,
  timeEntryStop,
  timeEntrySingleEntryUpdate,
  timeEntrySearchWithTodaysDate,
  timerDropDown,
  timerIsRunning,
  timerStaffId,
  timerTimeEntryStartDateTime,
  timerTimeEntryEndDateTime,
  timerJobId,
  timerNotes,
  timerBillableType,
  timerTimeRecordTypeUnbillableId,
  getTimeEntriesList,
  timeEntryStopSuccess,
  activeTimerTab,
  pauseTimer,
  timeEntryStartSuccess,
  timeEntrySingleEntryUpdateSuccess,
  timeEntryReduxStateDataSuccess,
  getSingleJobDetailsForTimer,
  getSingleJobDetailsForTimerSuccess,
  readSingleJob,
  addProductIdSuccess,
  actionEventFiredSuccess,
  renewToken,
  getAllOpportunitiesList,
} from "../../store/actions";
//Timer Helper
import TimeTrackingDropdownTimerHelper from "./TimeTrackingDropdownTimerHelper";
import ShiftClockPanel from "./ShiftClockPanel";
//SimpleBar
import SimpleBar from "simplebar-react";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty } from "lodash";

import { toast } from "react-toastify";
import moment from "moment";

import {
  timeFormatDateAndTime,
  timeFormatDateAndTimeNoSeconds,
} from "./HandleDateTime";
import JobCreateEdit from "../popUpComponents/JobCreateEdit";
import StopTimerChooseNext from "../popUpComponents/stopTimerChooseNext";
import { searchProductsAllowedTimeTracking } from "../../store/products/action";
import { searchSingleJobTaskListForTimer } from "../../store/tasksCrmIT/action";
import JobSearchList from "./JobSearchList";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import VoiceToTextAI from "../../pages/Prototyping/VoiceToText";
import AddMultipleTimeEntries from "../popUpComponents/AddMultipleTimeEntries";
import AppModal from "./AppModal";
import {
  isSystemModuleOn,
  SYSTEM_MODULE_CODES,
} from "../../helpers/functions/systemModules";
// FetchAPI (not APIClient) carries the login token - see ShiftClockPanel.
import { FetchAPI } from "../../helpers/APIdata/fetchAPI";

const TimeTrackingDropdown = () => {
  const localConfig_14X = JSON.parse(localStorage.getItem("authUser"))
    ?.get_configitem_data?.ZCONFIGVAL_14_X;

  // Timer-stop requirements (company default + per-staff override).
  //   ZCONFIGVAL_50_X — a task is required when stopping a billable timer
  //   ZCONFIGVAL_51_X — a note is required when stopping any timer
  const localConfig_50X = JSON.parse(localStorage.getItem("authUser"))
    ?.get_configitem_data?.ZCONFIGVAL_50_X;
  const localConfig_51X = JSON.parse(localStorage.getItem("authUser"))
    ?.get_configitem_data?.ZCONFIGVAL_51_X;

  // Job completion invoice review (per-staff opt-in). When '1', completing a
  // job from the timer opens the invoice line-item review flow instead of the
  // simple complete/add-task modal.
  const localConfig_52X = JSON.parse(localStorage.getItem("authUser"))
    ?.get_configitem_data?.ZCONFIGVAL_52_X;

  // Change #100213 - block a timer on an invoiced / proforma-invoiced job ONLY
  // when the company has opted in (ZCONFIGVAL_54_X), exactly as the backend
  // does in TimeEntryController::singletimerstop. It is off by default there.
  const localConfig_54X = JSON.parse(localStorage.getItem("authUser"))
    ?.get_configitem_data?.ZCONFIGVAL_54_X;

  const timeEntryDataInit = {
    Staff_Id: "",
    TimeEntryStartDateTime: "today",
    TimeEntryEndDateTime: "",
    Job_Id: "",
    Title: "",
    Customer_FullName: "",
    Job_Title: "",
    Task_Id: "",
    BillableType: "1",
    TimeEntryTypeUnbillable_Id: "",
    Opportunity_Id: "",
    Opportunity_Title: "",
    Notes: "",
    timerIsRunning: false,
    pauseTimer: false,
    activeTab: "1",
    timerStartTimerLoading: false,
    timeEntryStartSuccess: [],
    Product_Id: localConfig_14X ? localConfig_14X : "",
  };

  const { dropDownTimer } = useSelector((state) => ({
    dropDownTimer: state.dropDownReducer.timer_drop_down,
  }));
  const { timeEntryData } = useSelector((state) => ({
    timeEntryData: state.TimeEntries.timeEntryData,
  }));

  //Dropdown Toggle
  // Redux State Data management
  const {
    rBillableType,
    rJob_Id,
    rTask_Id,
    rTimeEntryTypeUnbillable_Id,
    rNotes,
    rTimeEntryStartDateTime,
    rTimeEntryEndDateTime,
    rtimerIsRunning,
    rActiveTab,
  } = useSelector((state) => ({
    rBillableType: state.TimeEntries.timeEntryData.timeentry_data.BillableType,
    rJob_Id: state.TimeEntries.timeEntryData.timeentry_data.Job_Id,
    rTask_Id: state.TimeEntries.timeEntryData.timeentry_data.Task_Id,
    rTimeEntryTypeUnbillable_Id:
      state.TimeEntries.timeEntryData.timeentry_data.TimeEntryTypeUnbillable_Id,
    rNotes: state.TimeEntries.timeEntryData.timeentry_data.Notes,
    rTimeEntryStartDateTime:
      state.TimeEntries.timeEntryData.timeentry_data.TimeEntryStartDateTime,
    rTimeEntryEndDateTime:
      state.TimeEntries.timeEntryData.timeentry_data.TimeEntryEndDateTime,
    rtimerIsRunning:
      state.TimeEntries.timeEntryData.timeentry_data.timerIsRunning,
    rActiveTab: state.TimeEntries.timeEntryData.timeentry_data.activeTab,
  }));
  const Staff_Id = JSON.parse(localStorage.getItem("authUser"))?.get_staff_data
    ?.Staff_Id;
  const [resetSearchQuery, setResetSearchQuery] = useState(false);
  const [isNotificationDropdown, setIsNotificationDropdown] =
    useState(dropDownTimer);

  const toggleNotificationDropdown = (e) => {
    // The job search results panel is portalled to document.body (clipping fix),
    // so reactstrap's outside-click detection sees clicks on it (Assign / Add
    // New Job) as outside the dropdown and would close the popup mid-click,
    // unmounting the panel before the button's handler runs.
    if (e?.target?.closest?.(".jobSearchList-search-results-wrapper")) return;
    setIsNotificationDropdown(!isNotificationDropdown);
    dispatch(timerDropDown(!isNotificationDropdown));
  };

  useEffect(() => {
    setIsNotificationDropdown(dropDownTimer);
  }, [dropDownTimer]);

  //Tab
  const [activeTab, setActiveTab] = useState("1");
  //Extras Collapse
  const [isExtrasOpen, setIsExtrasOpen] = useState(false);
  const [extrasTooltipOpen, setExtrasTooltipOpen] = useState(false);

  const handleAddMultipleTimers = () => {
    setModalMultipleTimeEntries(true);
    //close Time Tracking - keep redux in sync (Task 24839) so re-opening works
    setIsNotificationDropdown(false);
    dispatch(timerDropDown(false));
  };

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const dispatch = useDispatch();

  // Local Variables useState

  const [onCalendarOpen, setOnCalendarOpen] = useState(false);
  const [stopStartTimer, setStopStartTimer] = useState("");
  // When "Stop Start" chains a new timer, use the finished timer's End time as the
  // new Start time (instead of "now"). Handy when backdating entries. Persisted so
  // the preference sticks between sessions.
  const [chainStartFromPrevEnd, setChainStartFromPrevEnd] = useState(
    () => localStorage.getItem("timerChainStartFromPrevEnd") === "1"
  );
  // Holds the datetime the next chained timer should start from (the just-finished
  // timer's End time). Consumed once by the timer-start success handler.
  const stopStartNextStartRef = useRef(null);
  // create timer to start and stop on click and update every second
  const [seconds, setSeconds] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [hours, setHours] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");

  const [Customer_Id, setCustomer_Id] = useState("");

  const [todaysTimeEntries, setTodaysTimeEntries] = useState([]);
  const [selectedJob, setSelectedJob] = useState(null);

  const handleSelectJobFromSearchResults = (jobObject) => {
    dispatch(
      timeEntryReduxStateDataSuccess({
        timeentry_data: {
          ...timeEntryData.timeentry_data,
          Job_Id: jobObject?.Id,
          Job_Title: jobObject?.Title,
          Customer_FullName: jobObject?.Customer_FullName,
          // job changed so any previously selected task no longer applies
          Task_Id:
            jobObject?.Id === timeEntryData.timeentry_data.Job_Id
              ? timeEntryData.timeentry_data.Task_Id
              : "",
        },
      })
    );
    handleServerTimeEntrySingleEntryUpdate();
  };
  useEffect(() => {
    if (isEmpty(rJob_Id)) {
      setSelectedJob(null);
      // dispatch and update job id with ""
      dispatch(
        timeEntryReduxStateDataSuccess({
          timeentry_data: {
            ...timeEntryData.timeentry_data,
            Job_Id: "",
            Job_Title: "",
            Customer_FullName: "",
            Task_Id: "",
          },
        })
      );
      handleServerTimeEntrySingleEntryUpdate();
    } else {
      setSelectedJob({
        Id: rJob_Id,
        Title: timeEntryData.timeentry_data.Job_Title,
        Customer_FullName: timeEntryData.timeentry_data.Customer_FullName,
      });
      // fetch this job's tasks so the timer can be allocated to one directly
      dispatch(
        searchSingleJobTaskListForTimer([
          {
            task_data: {
              Job_Id: rJob_Id,
            },
          },
        ])
      );
    }
  }, [rJob_Id]);
  //Redux variables
  const { jobsListHeader } = useSelector((state) => ({
    jobsListHeader: state.Jobs.jobsData?.job_list,
  }));
  const { timeEntryTypeList } = useSelector((state) => ({
    timeEntryTypeList:
      state.TimeEntries.timeEntryTypes?.timeentrytypeunbillable_list,
  }));
  // The non-billable type flagged as "invoicing / admin" time - review time on
  // the job completion flow is logged against this so it never bills a customer.
  // Change #100074: non-billable (pre-sales) time can go against an open opportunity
  const { opportunityList } = useSelector((state) => ({
    opportunityList:
      state.Opportunities.getAllOpportunitiesList?.opportunity_list,
  }));
  const rOpportunity_Id = timeEntryData?.timeentry_data?.Opportunity_Id;
  const handleSelectOpportunity = (option) => {
    dispatch(
      timeEntryReduxStateDataSuccess({
        timeentry_data: {
          ...timeEntryData.timeentry_data,
          Opportunity_Id: option?.value ?? "",
          Opportunity_Title: option?.title ?? "",
          Customer_FullName: option?.customer ?? "",
        },
      })
    );
    handleServerTimeEntrySingleEntryUpdate();
  };
  const invoicingUnbillableTypeId = timeEntryTypeList?.find(
    (type) => type?.FlagInvoicingTime == "1"
  )?.Id;
  const { timeEntryListOpenLive } = useSelector((state) => ({
    timeEntryListOpenLive:
      state.TimeEntries.timeEntryListOpenLive?.timeentry_list,
  }));
  const { timeEntryListOpenLiveLoaded } = useSelector((state) => ({
    timeEntryListOpenLiveLoaded: state.TimeEntries.timeEntryListOpenLive,
  }));

  const { receivedTodaysTimeEntries } = useSelector((state) => ({
    receivedTodaysTimeEntries:
      state.TimeEntries.timeEntrySearchTodaysDate?.timeentry_list,
  }));

  const { timeEntryStopSuccessResponse } = useSelector((state) => ({
    timeEntryStopSuccessResponse: state.TimeEntries.timeEntryStopSuccess,
  }));
  // UseEffects functions ...
  const { timeEntryEndTimeDateTime } = useSelector((state) => ({
    timeEntryEndTimeDateTime:
      state.TimeEntries.timeEntryData.timeentry_data.TimeEntryEndDateTime,
  }));
  const { timerStartTimerLoadingAPI } = useSelector((state) => ({
    timerStartTimerLoadingAPI:
      state.TimeEntries.timeEntryData.timeentry_data.timerStartTimerLoading,
  }));

  const { searchProductsAllowedTimeTrackingList } = useSelector((state) => ({
    searchProductsAllowedTimeTrackingList:
      state.Products.searchProductsAllowedTimeTracking?.product_list,
  }));

  const { singleJobTasksListForTimer } = useSelector((state) => ({
    singleJobTasksListForTimer:
      state.TasksCrmIt.singleJobTasksListForTimer?.task_list,
  }));

  // Change #100215 - "the task dropdown is empty even though there are tasks
  // on this job". The options only kept tasks whose status had FlagActive
  // "1", so a job whose tasks were all closed - or had no status, which comes
  // back as NULL - offered nothing at all. Every task on the job is listed now:
  // open ones first, then the rest under "Closed tasks", so time can still be
  // put against the task it was really spent on.
  const timerTaskOptions = (() => {
    const toOption = (item) => ({
      label: "#" + item.Id + ", " + item?.Title,
      value: item.Id,
      id: item.Id,
    });
    const isOpen = (item) =>
      item?.TaskStatus_FlagActive == null ||
      String(item.TaskStatus_FlagActive) === "1";
    const list = singleJobTasksListForTimer || [];
    const open = list.filter(isOpen).map(toOption);
    const closed = list.filter((item) => !isOpen(item)).map(toOption);
    if (!closed.length) return open;
    return [
      ...(open.length ? [{ label: "Open tasks", options: open }] : []),
      { label: "Closed tasks", options: closed },
    ];
  })();

  // Change #24911. The list above is only fetched when the job changes, so a
  // task created after that (same job) is missing from it and the task picker
  // renders blank even though Task_Id is set - it looked as if Stop Timer had
  // not put the task on the timer. Refetch once per job/task pair when the
  // timer's task is not in the list.
  const refetchedTaskForTimerRef = useRef(null);
  useEffect(() => {
    if (!rJob_Id || !rTask_Id) return;
    if (singleJobTasksListForTimer?.some((item) => item.Id == rTask_Id)) return;
    const key = `${rJob_Id}:${rTask_Id}`;
    if (refetchedTaskForTimerRef.current === key) return;
    refetchedTaskForTimerRef.current = key;
    dispatch(
      searchSingleJobTaskListForTimer([{ task_data: { Job_Id: rJob_Id } }])
    );
  }, [rJob_Id, rTask_Id, singleJobTasksListForTimer]);

  // Change #100215 - also refresh the job's tasks each time the pop-out
  // opens: a task added to the job since it was last fetched (the list is
  // otherwise only loaded when the timer's job changes) was missing.
  useEffect(() => {
    if (!isNotificationDropdown || !rJob_Id) return;
    dispatch(
      searchSingleJobTaskListForTimer([{ task_data: { Job_Id: rJob_Id } }])
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isNotificationDropdown]);

  // Helper Functions
  const helperGetNewDataLists = () => {
    // dispatch(getTimeEntriesList());
    dispatch(
      timeEntrySearchWithTodaysDate([
        {
          timeentry_data: {
            Staff_Id: Staff_Id,
            TimeEntryStartDateTime: timeFormatDateAndTime(new Date()).split(
              " "
            )[0],
          },
        },
      ])
    );
    dispatch(
      searchProductsAllowedTimeTracking([
        {
          product_data: {
            AllowTimeTracking: 1,
          },
        },
      ])
    );
  };

  useEffect(() => {
    dispatch(
      timeEntryListOpen([
        {
          timeentry_data: {
            Staff_Id: Staff_Id,
          },
        },
      ])
    );
    helperGetNewDataLists();
  }, []);

  //when browser comes off sleep mode to live mode fetch timeEntryListOpen again to get up to date info
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        dispatch(
          timeEntryListOpen([
            {
              timeentry_data: {
                Staff_Id: Staff_Id,
              },
            },
          ])
        );
      }
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  useEffect(() => {
    if (isEmpty(receivedTodaysTimeEntries)) return;
    setTodaysTimeEntries(
      receivedTodaysTimeEntries?.sort((a, b) => {
        return (
          new Date(b?.TimeEntryStartDateTime) -
          new Date(a?.TimeEntryStartDateTime)
        );
      })
    );
  }, [receivedTodaysTimeEntries]);

  useEffect(() => {
    // Task 24827 - this REPLACES timeentry_data wholesale from the server's
    // open entry, Task_Id included. The save above is debounced by 400ms, so
    // anything that refreshed the open list inside that window used to
    // overwrite the task the user had just picked with the one the server
    // still had - and then the debounced save wrote the overwritten values
    // back, making the change disappear with no error anywhere.
    //
    // actionEventFired means "a local edit is waiting to be saved", so
    // hydration stands aside until it has been. Deliberately NOT in the
    // dependency array: re-running when the flag clears would hydrate from
    // the list as it was fetched BEFORE the save, which is the same clobber
    // one step later. The next genuine refresh of the list hydrates normally.
    if (actionEventFired) return;

    if (!isEmpty(timeEntryListOpenLive)) {
      dispatch(
        timeEntryReduxStateDataSuccess({
          timeentry_data: {
            Staff_Id: Staff_Id,
            TimeEntryStartDateTime:
              timeEntryListOpenLive[0]?.TimeEntryStartDateTime,
            TimeEntryEndDateTime: "",
            Job_Id: timeEntryListOpenLive[0]?.Job_Id ?? "",
            Customer_FullName:
              timeEntryListOpenLive[0]?.Customer_FullName ?? "",
            Job_Title: timeEntryListOpenLive[0]?.Job_Title ?? "",
            Task_Id: timeEntryListOpenLive[0]?.Task_Id ?? "",
            BillableType: timeEntryListOpenLive[0]?.BillableType ?? "",
            TimeEntryTypeUnbillable_Id:
              timeEntryListOpenLive[0]?.TimeEntryTypeUnbillable_Id ?? "",
            Opportunity_Id: timeEntryListOpenLive[0]?.Opportunity_Id ?? "",
            Opportunity_Title:
              timeEntryListOpenLive[0]?.Opportunity_Title ?? "",
            Notes: timeEntryListOpenLive[0]?.Notes ?? "",
            timerIsRunning: true,
            pauseTimer: false,
            activeTab: "1",
            timerStartTimerLoading: false,
            timeEntryStartSuccess: [],
            Product_Id: timeEntryListOpenLive[0]?.Product_Id ?? "",
          },
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timeEntryListOpenLive]);

  useEffect(() => {
    if (rTimeEntryStartDateTime !== "today") {
      const date = new Date();
      const Now =
        date.getFullYear() +
        "-" +
        (date.getMonth() + 1 < 9
          ? date.getMonth() + 1
          : "0" + (date.getMonth() + 1)) +
        // (date.getMonth() + 1) +
        "-" +
        (date.getDate() < 9 ? date.getDate() : "0" + date.getDate()) +
        // date.getDate() +
        " " +
        (date.getHours() < 9 ? date.getHours() : "0" + date.getHours()) +
        // date.getHours() +
        ":" +
        (date.getMinutes() < 9 ? date.getMinutes() : "0" + date.getMinutes()) +
        // date.getMinutes() +
        ":" +
        (date.getSeconds() < 9 ? "0" : "") +
        date.getSeconds();

      const diff = new Date(Now) - new Date(rTimeEntryStartDateTime);
      const hrs = Math.floor(diff / 3600000);
      const min = Math.floor((diff % 3600000) / 60000);
      const sec = Math.floor(((diff % 3600000) % 60000) / 1000);

      setHours(hrs);
      setMinutes(min);
      setSeconds(sec);
    }
  }, [rTimeEntryStartDateTime]);

  // Change #100437 - opening an empty End picker used to jump to today, which
  // is a nuisance when back-dating (start 1 June, end lands on today). The End
  // now opens on the Start's date at the current time of day; if that would
  // fall before the Start, it opens on the Start itself.
  const defaultEndDateTime = () => {
    const now = moment();
    const start =
      rTimeEntryStartDateTime && rTimeEntryStartDateTime !== "today"
        ? moment(rTimeEntryStartDateTime)
        : null;
    if (!start || !start.isValid() || start.isSame(now, "day")) {
      return now.toDate();
    }
    const end = start
      .clone()
      .hours(now.hours())
      .minutes(now.minutes())
      .seconds(0);
    return (end.isBefore(start) ? start : end).toDate();
  };

  useEffect(() => {
    if (isEmpty(jobsListHeader) && isNotificationDropdown === true) {
      dispatch(getJobsData());
    }
    if (isEmpty(timeEntryTypeList) && isNotificationDropdown === true) {
      dispatch(getTimeEntryTypeList());
    }
    if (isEmpty(opportunityList) && isNotificationDropdown === true) {
      dispatch(getAllOpportunitiesList());
    }
  }, [isNotificationDropdown]);

  // Check if values changed update Redux State
  useEffect(() => {
    dispatch(timerStaffId(Staff_Id));
  }, [Staff_Id]);

  // Start Timer from redux if timer is set to running
  useEffect(() => {
    if (!rtimerIsRunning) return;
    if (!isEmpty(timeEntryListOpenLive)) return;
    handleStartTimer();
  }, [rtimerIsRunning]);

  //on change of timeEntryData update database api call
  // controlled useEffect with action in active state:
  const { actionEventFired } = useSelector((state) => ({
    actionEventFired: state.TimeEntries.actionEventFired,
  }));

  // Task 24827 - "when i click this button in the pop out timer the task isnt
  // being set".
  //
  // Everything that changes the running timer - picking a task, assigning the
  // timer to this task, opening the stop popup from a task page - writes to
  // the shared timeentry_data and then raises actionEventFired, and THIS
  // effect is the only thing that ever sends it to the server. It had two
  // holes, and a request that falls down either one is lost in silence: the
  // screen shows the new task, the server never hears about it.
  //
  // 1. actionEventFired WAS NOT A DEPENDENCY. The effect was keyed on
  //    timeEntryData alone, so a save raised in a render where the data did
  //    not ALSO change never ran at all. handleStartTimer on the task page
  //    does exactly that - it fires timeEntryStart (async) and then raises
  //    the flag.
  //
  // 2. WHEN THE TIMER WAS NOT RUNNING THE FLAG WAS NEVER CLEARED. The old
  //    code simply fell out of the if, leaving actionEventFired stuck true
  //    for the rest of the session. That is worse than dropping the save,
  //    because the next unrelated change to timeEntryData then fired a save
  //    of whatever happened to be in the store at that moment.
  useEffect(() => {
    if (!actionEventFired) return;

    if (!rtimerIsRunning) {
      // Nothing to save against. Clear it rather than leaving it armed.
      dispatch(actionEventFiredSuccess(false));
      return;
    }

    const delay = setTimeout(() => {
      dispatch(timeEntrySingleEntryUpdate([timeEntryData]));
      dispatch(actionEventFiredSuccess(false));
    }, 400);
    return () => clearTimeout(delay);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timeEntryData, actionEventFired]);

  const handleServerTimeEntrySingleEntryUpdate = () => {
    dispatch(actionEventFiredSuccess(true));
  };

  const { timeEntryUpdateSuccessAPI } = useSelector((state) => ({
    timeEntryUpdateSuccessAPI: state.TimeEntries.timeEntryUpdate,
  }));
  //local user Id
  const userId = JSON.parse(localStorage.getItem("authUser"))?.get_user_data
    ?.User_Id;
  const companyId = JSON.parse(localStorage.getItem("authUser"))?.get_user_data
    ?.Company_IdExternal;

  // Stop Timer
  useEffect(() => {
    if (isEmpty(timeEntryStopSuccessResponse)) return;
    if (timeEntryStopSuccessResponse.status === 200) {
      // clear local State
      setMinutes(0);
      setSeconds(0);
      setHours(0);

      if (pendingInvoiceReviewTimerRef.current) {
        // Job completion invoice-review flow: the billable timer has committed
        // (its priced JobInvoiceItem line now exists), so the modal can load it.
        pendingInvoiceReviewTimerRef.current = false;
        setInvoiceReviewReady(true);

        if (invoicingUnbillableTypeId) {
          // Start a non-billable "invoicing / admin" timer for the review period
          // so the time spent reviewing/editing the invoice is not billed to any
          // customer.
          dispatch(
            timeEntryReduxStateDataSuccess({
              timeentry_data: {
                ...timeEntryDataInit,
                Staff_Id: Staff_Id,
                TimeEntryStartDateTime: "today",
                TimeEntryEndDateTime: "",
                Job_Id: "",
                Task_Id: "",
                BillableType: "2",
                TimeEntryTypeUnbillable_Id: invoicingUnbillableTypeId,
                Notes: "",
                timerIsRunning: false,
                pauseTimer: false,
                activeTab: "1",
                timerStartTimerLoading: false,
                timeEntryStartSuccess: [],
                Product_Id: "",
              },
            })
          );
          dispatch(
            timeEntryStart([{ timeentry_data: { Staff_Id: Staff_Id } }])
          );
        } else {
          // No invoicing type configured - just clear the timer as normal.
          dispatch(
            timeEntryReduxStateDataSuccess({
              timeentry_data: {
                ...timeEntryDataInit,
                Staff_Id: Staff_Id,
                Product_Id: localConfig_14X ?? "",
              },
            })
          );
        }

        helperGetNewDataLists();
      } else {
        // clear redux state
        dispatch(
          timeEntryReduxStateDataSuccess({
            timeentry_data: {
              ...timeEntryDataInit,
              Staff_Id: Staff_Id,
              TimeEntryStartDateTime: "today",
              TimeEntryEndDateTime: "",
              Job_Id: "",
              Task_Id: "",
              BillableType: "1",
              TimeEntryTypeUnbillable_Id: "",
              Notes: "",
              timerIsRunning: false,
              pauseTimer: false,
              activeTab: "1",
              timerStartTimerLoading: false,
              timeEntryStartSuccess: [],
              Product_Id: localConfig_14X ?? "",
            },
          })
        );

        // dispatch(getTimeEntriesList());
        if (stopStartTimer === "stopStart") {
          handleStartTimer();
          setSearchQuery("");
        }

        helperGetNewDataLists();
      }
      if (rJob_Id) {
        dispatch(readSingleJob({ id: rJob_Id }));
      }
    } else {
      toast.error(timeEntryStopSuccessResponse.message);
      // Change #100078 - a non-billable stop flips timerIsRunning off before the
      // call, so a refused stop left the timer looking stopped while the server
      // row was still open. Re-read the open entry so the UI matches the server.
      dispatch(timeEntryListOpen([{ timeentry_data: { Staff_Id: Staff_Id } }]));
    }
    dispatch(timeEntryStopSuccess([]));
  }, [timeEntryStopSuccessResponse]);

  const handleStartTimer = () => {
    if (timerStartTimerLoadingAPI === true) return;
    if (rtimerIsRunning) return;
    dispatch(
      timeEntryStart([
        {
          timeentry_data: {
            Staff_Id: Staff_Id,
            // Job_Id: "",
            // BillableType: "",
          },
        },
      ])
    );
    // dispatch(timerIsRunning(true));
    handleServerTimeEntrySingleEntryUpdate();
  };
  const { timeEntryStartSuccessAPI } = useSelector((state) => ({
    timeEntryStartSuccessAPI:
      state.TimeEntries.timeEntryData.timeentry_data.timeEntryStartSuccess,
  }));
  useEffect(() => {
    if (isEmpty(timeEntryStartSuccessAPI)) return;
    if (timeEntryStartSuccessAPI.status === 200) {
      let date;
      if (stopStartNextStartRef.current) {
        // Chained "Stop Start": begin the new timer at the finished timer's End time.
        date = stopStartNextStartRef.current;
        stopStartNextStartRef.current = null;
      } else if (rTimeEntryStartDateTime === "today") {
        date = new Date();
      } else {
        date = rTimeEntryStartDateTime;
      }
      dispatch(timerIsRunning(true));
      dispatch(timerTimeEntryStartDateTime(timeFormatDateAndTime(date)));
      handleServerTimeEntrySingleEntryUpdate();
    } else {
      toast.error(timeEntryStartSuccessAPI.message);
    }
    dispatch(timeEntryStartSuccess([]));
  }, [timeEntryStartSuccessAPI]);

  // Change #100694 - void (discard) the running timer. A timer left running
  // for days blocked clock out, and Stop would have logged every hour of it.
  // The server deletes the caller's own open entry; an open entry has no job
  // or task time rows yet, so nothing else needs undoing. The panel is then
  // reset exactly as a successful stop resets it, minus the stop side effects
  // (Stop Start restart, job-complete prompt, invoice review).
  const [modalVoidTimer, setModalVoidTimer] = useState(false);
  const [voidingTimer, setVoidingTimer] = useState(false);
  const handleVoidTimer = async () => {
    if (voidingTimer) return;
    setVoidingTimer(true);
    try {
      const res = await FetchAPI("/timeentry/singletimervoid", "POST", {});
      if (res?.status === 200) {
        toast.success(res.message || "Timer voided");
        setModalVoidTimer(false);
        stopListening();
        setSearchQuery("");
        setMinutes(0);
        setSeconds(0);
        setHours(0);
        dispatch(
          timeEntryReduxStateDataSuccess({
            timeentry_data: {
              ...timeEntryDataInit,
              Staff_Id: Staff_Id,
              Product_Id: localConfig_14X ?? "",
            },
          })
        );
        helperGetNewDataLists();
      } else {
        toast.error(res?.message || "Could not void the timer");
        // Bring the panel back in line with whatever the server holds.
        dispatch(
          timeEntryListOpen([{ timeentry_data: { Staff_Id: Staff_Id } }])
        );
      }
    } catch (e) {
      toast.error(
        typeof e === "string" ? e : e?.message || "Could not void the timer"
      );
    } finally {
      setVoidingTimer(false);
    }
  };

  // Change #100695 - Staff.FlagHideTimer (reported by ShiftClockPanel from
  // /staffclock/status): staff who clock in but never time jobs see only the
  // clock in / out part. A timer that is somehow already running stays
  // visible so it can still be stopped or voided.
  const [hideTimer, setHideTimer] = useState(false);
  // Change #100696 - or the company has the Job Timer module switched off
  // (Settings > Modules). Read on each render, so it follows the Modules page
  // updating localStorage without a re-login.
  const timerHidden =
    (hideTimer || !isSystemModuleOn(SYSTEM_MODULE_CODES.TIME_TRACKING)) &&
    !rtimerIsRunning;

  const handleStopTimer = () => {
    if (rBillableType == "1") {
      if (!timeEntryData.timeentry_data.Job_Id) {
        toast.error("Please select a job");
        return;
      }
      // Note mandatory (company/staff config) — billable stops only
      if (
        localConfig_51X == "1" &&
        !timeEntryData.timeentry_data.Notes?.trim()
      ) {
        toast.error("Please add a note before stopping the timer");
        return;
      }
      // Task mandatory (company/staff config) — billable stops only
      if (localConfig_50X == "1" && !timeEntryData.timeentry_data.Task_Id) {
        toast.error("Please select a task");
        return;
      }
    }

    if (rBillableType == "2") {
      if (
        !timeEntryData.timeentry_data.TimeEntryTypeUnbillable_Id &&
        !timeEntryData.timeentry_data.Opportunity_Id
      ) {
        toast.error("Please select a time entry type or an opportunity");
        return;
      }
    }
    if (rBillableType == "1") {
      // Billable Jobs

      // Get single job up to date info from database and check if it has tasks and if job completed
      dispatch(getSingleJobDetailsForTimer({ id: rJob_Id }));
    }
    if (rBillableType == "2") {
      // Non Billable : Jobs no checks just start stop
      dispatch(timerIsRunning(false));
      dispatch(timeEntryStop([timeEntryData]));
    }
    handleServerTimeEntrySingleEntryUpdate();
    // reset voice to text transcript
    stopListening();
    setSearchQuery("");
  };
  const { singleJobDetailsForTimerAPI } = useSelector((state) => ({
    singleJobDetailsForTimerAPI: state.SingleJob.singleJobDetailsForTimer,
  }));
  useEffect(() => {
    if (isEmpty(singleJobDetailsForTimerAPI)) return;
    if (singleJobDetailsForTimerAPI.status === 200) {
      // Change #100213 - this used to refuse ANY invoiced job: "Job is
      // already invoiced" popped up and the stop went no further, even though
      // the server accepts the time unless the company turned the block on.
      if (
        String(localConfig_54X) === "1" &&
        (singleJobDetailsForTimerAPI?.job_data?.FlagInvoiced === "1" ||
          singleJobDetailsForTimerAPI?.job_data?.FlagProformaInvoiced === "1")
      ) {
        toast.error(
          singleJobDetailsForTimerAPI?.job_data?.FlagInvoiced === "1"
            ? "Job is already invoiced"
            : "Job is already proforma invoiced"
        );
      } else {
        if (singleJobDetailsForTimerAPI?.job_data?.Customer_Id) {
          setCustomer_Id(singleJobDetailsForTimerAPI?.job_data?.Customer_Id);
        }
        if (
          singleJobDetailsForTimerAPI?.job_data?.JobStatus_FlagActive === "0"
        ) {
          // check if any there any open tasks
          dispatch(timerIsRunning(false));
          dispatch(timeEntryStop([timeEntryData]));
          setModalStopTimerAndChooseNext(false);
        } else {
          if (
            singleJobDetailsForTimerAPI?.task_summary?.count_open_tasks !== 0
          ) {
            dispatch(timerIsRunning(false));
            dispatch(timeEntryStop([timeEntryData]));
            setModalStopTimerAndChooseNext(false);
          } else {
            // Set Job Completed or add more tasks. Reset the invoice-review
            // flow state for a fresh open.
            setInvoiceReviewReady(false);
            pendingInvoiceReviewTimerRef.current = false;
            setReviewJobId("");
            setReviewCustomer_Id("");
            setModalStopTimerAndChooseNext(true);
          }
        }
      }
    } else {
      toast.error(singleJobDetailsForTimerAPI.message);
      // continue with timer running
    }
    dispatch(getSingleJobDetailsForTimerSuccess([]));
  }, [singleJobDetailsForTimerAPI]);

  const convertMinsToHrsMins = (mins) => {
    let h = Math.floor(mins / 60);
    let m = mins % 60;
    h = h < 10 ? "0" + h : h;
    m = m < 10 ? "0" + m : m;
    return (h > 0 ? h + " h " : "") + (m > 0 || h > 0 ? m + " min" : "--");
  };

  // Handle
  const handleAssignTimeEntryToTimer = (timeEntry) => {
    dispatch(timerBillableType(timeEntry.BillableType));
    if (timeEntry.BillableType == "1") {
      dispatch(timerJobId(timeEntry.Job_Id));
      dispatch(
        timeEntryReduxStateDataSuccess({
          timeentry_data: {
            ...timeEntryData.timeentry_data,

            Job_Id: timeEntry?.Job_Id,
            Job_Title: timeEntry?.Job_Title,
            Customer_FullName: timeEntry?.Customer_FullName,
            Task_Id: timeEntry?.Task_Id ?? "",
            BillableType: "1",
            // Change #100091 - opportunities are for non-billable time only;
            // don't carry one over from whatever the timer held before.
            Opportunity_Id: "",
            Opportunity_Title: "",
          },
        })
      );
    }
    if (timeEntry.BillableType == "2") {
      dispatch(
        timerTimeRecordTypeUnbillableId(timeEntry?.TimeEntryTypeUnbillable_Id)
      );
      // Change #100091 - put the entry's opportunity (Change #100074) back in
      // the "Allocate to Opportunity" dropdown, or clear it if the entry had
      // none. The type is set here too: this spread is of the state before the
      // dispatch above, so leaving it out would put the old type back.
      dispatch(
        timeEntryReduxStateDataSuccess({
          timeentry_data: {
            ...timeEntryData.timeentry_data,
            BillableType: "2",
            TimeEntryTypeUnbillable_Id:
              timeEntry?.TimeEntryTypeUnbillable_Id ?? "",
            Opportunity_Id: timeEntry?.Opportunity_Id ?? "",
            Opportunity_Title: timeEntry?.Opportunity_Title ?? "",
            Customer_FullName: timeEntry?.Opportunity_Id
              ? timeEntry?.Customer_FullName ?? ""
              : timeEntryData.timeentry_data?.Customer_FullName ?? "",
          },
        })
      );
    }
    toggleTab("1");
    dispatch(actionEventFiredSuccess(true));
  };
  useEffect(() => {
    if (activeTab !== rActiveTab) {
      setActiveTab(rActiveTab);
    }
  }, [rActiveTab]);

  useEffect(() => {
    if (activeTab !== rActiveTab) {
      dispatch(activeTimerTab(activeTab));
    }
  }, [activeTab]);

  const [moduleCreateJob, setModuleCreateJob] = useState(false);
  const toggleModuleCreateJob = () => {
    setModuleCreateJob(!moduleCreateJob);
  };
  const [modalStopTimerAndChooseNext, setModalStopTimerAndChooseNext] =
    useState(false);
  const toggleModalStopTimerAndChooseNext = () => {
    // reset the invoice-review flow state whenever the modal closes/reopens
    setInvoiceReviewReady(false);
    pendingInvoiceReviewTimerRef.current = false;
    setReviewJobId("");
    setReviewCustomer_Id("");
    setModalStopTimerAndChooseNext(!modalStopTimerAndChooseNext);
  };

  // Job completion invoice-review flow (gated by localConfig_52X).
  const [invoiceReviewReady, setInvoiceReviewReady] = useState(false);
  const pendingInvoiceReviewTimerRef = useRef(false);
  // Captured at review start because stopping the timer clears the live Job id.
  const [reviewJobId, setReviewJobId] = useState("");
  const [reviewCustomer_Id, setReviewCustomer_Id] = useState("");

  // Called from the completion modal ("Mark Complete & Review Invoice"). Commits
  // the billable timer (freezing the end at now, generating the priced line),
  // and flags that a non-billable invoicing timer should start once that lands.
  const handleStartInvoiceReview = () => {
    setReviewJobId(rJob_Id);
    setReviewCustomer_Id(Customer_Id);
    setInvoiceReviewReady(false);
    pendingInvoiceReviewTimerRef.current = true;
    dispatch(timerIsRunning(false));
    dispatch(timeEntryStop([timeEntryData]));
  };

  const startListening = () => {
    //https://www.npmjs.com/package/react-speech-recognition
    SpeechRecognition.startListening({ continuous: true, language: "en-GB" });
  };
  const stopListening = () => {
    SpeechRecognition.stopListening();
    resetTranscript();
  };

  const { transcript, resetTranscript, listening } = useSpeechRecognition();

  useEffect(() => {
    if (!listening) return;
    dispatch(timerNotes(transcript));
    handleServerTimeEntrySingleEntryUpdate();
  }, [transcript, listening]);

  const clearText = () => {
    dispatch(timerNotes(""));
    handleServerTimeEntrySingleEntryUpdate();
    //resetTranscript
    resetTranscript();
  };

  //Additional Timer Entries Module
  const [modalMultipleTimeEntries, setModalMultipleTimeEntries] =
    useState(false);
  const toggleModalMultipleTimeEntries = () => {
    setModalMultipleTimeEntries(!modalMultipleTimeEntries);
  };

  return (
    <React.Fragment>
      <AppModal
        open={modalVoidTimer}
        onClose={() => setModalVoidTimer(false)}
        title="Void this timer?"
        icon={<i className="ri-delete-bin-line" />}
        size="xs"
        loading={voidingTimer}
        onSubmit={handleVoidTimer}
        submitLabel="Void timer"
        submitColor="error"
      >
        <p className="mb-2">
          The running timer will be discarded and{" "}
          <strong>no time will be logged</strong>. This cannot be undone.
        </p>
        <ul className="list-unstyled mb-0 fs-13 text-muted">
          {(rJob_Id || timeEntryData?.timeentry_data?.Job_Title) && (
            <li>
              Job:{" "}
              <span className="text-body">
                {rJob_Id ? `#${rJob_Id} ` : ""}
                {timeEntryData?.timeentry_data?.Job_Title ?? ""}
              </span>
            </li>
          )}
          {timeEntryData?.timeentry_data?.Customer_FullName && (
            <li>
              Customer:{" "}
              <span className="text-body">
                {timeEntryData.timeentry_data.Customer_FullName}
              </span>
            </li>
          )}
          {rTimeEntryStartDateTime && rTimeEntryStartDateTime !== "today" && (
            <li>
              Started:{" "}
              <span className="text-body">
                {moment(rTimeEntryStartDateTime).format("ddd D MMM YYYY HH:mm")}
              </span>{" "}
              (
              {Math.floor(
                moment().diff(moment(rTimeEntryStartDateTime), "minutes") / 60
              )}
              h {moment().diff(moment(rTimeEntryStartDateTime), "minutes") % 60}
              m ago)
            </li>
          )}
        </ul>
      </AppModal>
      {modalStopTimerAndChooseNext && (
        <StopTimerChooseNext
          modal={modalStopTimerAndChooseNext}
          toggle={toggleModalStopTimerAndChooseNext}
          Job_Id={reviewJobId || rJob_Id}
          Customer_Id={reviewCustomer_Id || Customer_Id}
          Staff_Id={Staff_Id}
          invoiceReviewEnabled={localConfig_52X == "1"}
          invoiceReviewReady={invoiceReviewReady}
          onStartInvoiceReview={handleStartInvoiceReview}
        />
      )}
      <>
        {moduleCreateJob && (
          <JobCreateEdit
            modal={moduleCreateJob}
            setModal={setModuleCreateJob}
            toggle={toggleModuleCreateJob}
            isEdit={false}
            // Task 24840 - assign the just-created job to the timer so you can
            // start timing against it immediately, instead of navigating away.
            // `created` is the create form (Title etc.); the customer name
            // hydrates from the server's open time entry on the next refresh.
            onJobCreated={(jobId, created) => {
              dispatch(
                timeEntryReduxStateDataSuccess({
                  timeentry_data: {
                    ...timeEntryData.timeentry_data,
                    BillableType: "1",
                    Job_Id: jobId,
                    Job_Title: created?.Title ?? "",
                    Task_Id: "",
                  },
                })
              );
              handleServerTimeEntrySingleEntryUpdate();
              setSearchQuery("");
            }}
          />
        )}
      </>
      <Dropdown
        isOpen={!onCalendarOpen ? isNotificationDropdown : true}
        toggle={toggleNotificationDropdown}
        className="topbar-head-dropdown ms-1 header-item"
      >
        <DropdownToggle
          type="button"
          tag="button"
          className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
        >
          {!rtimerIsRunning ? (
            <i
              className={
                timerHidden ? "fa-regular fa-clock" : "fa-solid fa-play"
              }
            ></i>
          ) : (
            <TimeTrackingDropdownTimerHelper
              Rseconds={seconds}
              Rminutes={minutes}
              Rhours={hours}
              handleStartTimer={handleStartTimer}
              startDate={rTimeEntryStartDateTime}
              endDate={rTimeEntryEndDateTime}
              clockSize={"icon"}
            />
          )}
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-0 TimeTracking-drop-down-menu  ">
          <div
            className={"timer-outside-main-container"}
            style={timerHidden ? { display: "none" } : undefined}
          >
            <TimeTrackingDropdownTimerHelper
              Rseconds={seconds}
              Rminutes={minutes}
              Rhours={hours}
              handleStartTimer={handleStartTimer}
              startDate={rTimeEntryStartDateTime}
              endDate={rTimeEntryEndDateTime}
            />
          </div>
          <div className={"close-timer-popup-module-button"}>
            <button
              type="button"
              onClick={() => {
                // Keep redux in sync (Task 24839): closing only the local flag
                // left dropDownTimer stuck at true, so a later Stop Timer that
                // dispatches timerDropDown(true) was a no-op and the window
                // never re-opened.
                setIsNotificationDropdown(false);
                dispatch(timerDropDown(false));
              }}
              className="close-timer-popup-module-button-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              x
            </button>
          </div>
          <div className="dropdown-head bg-primary bg-pattern rounded-top">
            <div className="p-3">
              <Row className="align-items-center">
                <Col>
                  <h6 className="m-0 fs-16 fw-semibold text-white">
                    {" "}
                    Time Tracking{" "}
                  </h6>
                </Col>
                <div className="col-auto dropdown-tabs"></div>
              </Row>
            </div>

            {!timerHidden && (
              <div className="px-2 pt-2">
                <Nav className="nav-tabs dropdown-tabs nav-tabs-custom">
                  <NavItem>
                    <NavLink
                      href="#"
                      className={classnames({ active: activeTab === "1" })}
                      onClick={() => {
                        toggleTab("1");
                      }}
                    >
                      {" "}
                      NOW{" "}
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      href="#"
                      className={classnames({ active: activeTab === "2" })}
                      onClick={() => {
                        toggleTab("2");
                      }}
                    >
                      Today ({todaysTimeEntries?.length})
                    </NavLink>
                  </NavItem>
                </Nav>
              </div>
            )}
          </div>

          {/* Change #100332 - clock in / out for the shift, for staff who
              only use the web portal and never touch the wall tablet. */}
          <ShiftClockPanel
            open={!onCalendarOpen ? isNotificationDropdown : true}
            timerRunning={!!rtimerIsRunning}
            onHideTimerChange={setHideTimer}
          />

          {!timerHidden && (
            <TabContent activeTab={activeTab}>
              <TabPane tabId="1" className="py-2 ps-2">
                <div style={{ maxHeight: "100vh" }} className="pe-2">
                  <div
                    className={
                      "d-flex align-items-center p-2 justify-content-center"
                    }
                    style={{ width: "100%" }}
                  >
                    <div className="d-flex align-items-center ">
                      <div className={"d-flex align-items-center "}>
                        {/*radio 2 buttons Billable Non Billable*/}
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="inlineRadioOptions"
                            id="inlineRadio1"
                            value={rBillableType}
                            checked={rBillableType == "1"}
                            onChange={() => {
                              dispatch(timerBillableType("1"));
                              handleServerTimeEntrySingleEntryUpdate();
                            }}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineRadio1"
                          >
                            Billable
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="inlineRadioOptions"
                            id="inlineRadio2"
                            value={rBillableType}
                            checked={rBillableType == "2"}
                            onChange={() => {
                              dispatch(timerBillableType("2"));
                              handleServerTimeEntrySingleEntryUpdate();
                            }}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineRadio1"
                          >
                            None Billable
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className={
                      "d-flex align-items-center p-2 justify-content-center"
                    }
                    style={{ width: "100%" }}
                  >
                    {rBillableType && (
                      <div
                        className={"d-flex align-items-center  select-job-1"}
                      >
                        {/*radio 2 buttons Billable Non Billable*/}
                        {rBillableType == "1" ? (
                          <div className={"d-flex flex-column"}>
                            <div className={"mb-2 job-select3"}>
                              <JobSearchList
                                handleSelectJobFromSearchResults={
                                  handleSelectJobFromSearchResults
                                }
                                selectedJob={selectedJob}
                                dropDownTimer={true}
                                searchQuery={searchQuery}
                                resetSearchQuery={resetSearchQuery}
                                setSearchQuery={setSearchQuery}
                                // Task 24840 - "can i create a job from this
                                // screen". Open the create-job modal already
                                // wired below straight from the timer pop-out.
                                onAddNewJob={() => setModuleCreateJob(true)}
                              />
                            </div>

                            <div className={"text-start"}>
                              {!isEmpty(
                                searchProductsAllowedTimeTrackingList
                              ) && (
                                <div>
                                  <Select
                                    isClearable
                                    className="mb-2 job-select3 "
                                    placeholder={"Select Product..."}
                                    value={(() => {
                                      const productId =
                                        timeEntryData.timeentry_data.Product_Id;
                                      const matchedProduct =
                                        searchProductsAllowedTimeTrackingList?.find(
                                          (item) => item.Id == productId
                                        );
                                      // Only show a value chip when the seeded/selected
                                      // Product_Id actually maps to a known product.
                                      // A stale/invalid config default (e.g. ZCONFIGVAL_14_X)
                                      // would otherwise render "#<id>, undefined".
                                      if (!productId || !matchedProduct) {
                                        return [];
                                      }
                                      return {
                                        label:
                                          "#" +
                                          productId +
                                          ", " +
                                          matchedProduct.Name,
                                        value: matchedProduct.Id,
                                        id: matchedProduct.Id,
                                      };
                                    })()}
                                    onChange={(e) => {
                                      dispatch(addProductIdSuccess(e?.id));
                                      handleServerTimeEntrySingleEntryUpdate();
                                      //on clear set to empty
                                      if (isEmpty(e)) {
                                        dispatch(addProductIdSuccess(""));
                                      }
                                    }}
                                    options={
                                      !isEmpty(
                                        searchProductsAllowedTimeTrackingList
                                      )
                                        ? searchProductsAllowedTimeTrackingList?.map(
                                            (item) => ({
                                              label:
                                                "#" +
                                                item.Id +
                                                ", " +
                                                item?.Name,
                                              value: item.Id,
                                              id: item.Id,
                                            })
                                          )
                                        : []
                                    }
                                    // components={{ Menu: CustomMenu }}
                                    id="billable-select"
                                  ></Select>
                                </div>
                              )}
                            </div>
                            <div className={"text-start"}>
                              {rJob_Id &&
                                !isEmpty(singleJobTasksListForTimer) && (
                                  <div>
                                    <Select
                                      isClearable
                                      className="mb-2 job-select3 "
                                      placeholder={"Select Task..."}
                                      value={
                                        rTask_Id &&
                                        singleJobTasksListForTimer?.find(
                                          (item) => item.Id == rTask_Id
                                        )
                                          ? {
                                              label:
                                                "#" +
                                                rTask_Id +
                                                ", " +
                                                singleJobTasksListForTimer?.find(
                                                  (item) => item.Id == rTask_Id
                                                )?.Title,
                                            }
                                          : []
                                      }
                                      onChange={(e) => {
                                        dispatch(
                                          timeEntryReduxStateDataSuccess({
                                            timeentry_data: {
                                              ...timeEntryData.timeentry_data,
                                              Task_Id: e?.id ?? "",
                                            },
                                          })
                                        );
                                        handleServerTimeEntrySingleEntryUpdate();
                                      }}
                                      options={timerTaskOptions}
                                      id="task-select"
                                    ></Select>
                                  </div>
                                )}
                            </div>
                          </div>
                        ) : (
                          <div className={"ps-2 pe-2"}>
                            <Select
                              isClearable
                              className="mb-2 job-select3 "
                              placeholder={"Select Non-Billable Reason..."}
                              value={
                                isEmpty(rTimeEntryTypeUnbillable_Id)
                                  ? []
                                  : {
                                      label:
                                        "#" +
                                        rTimeEntryTypeUnbillable_Id +
                                        ", " +
                                        timeEntryTypeList?.find(
                                          (item) =>
                                            item.Id ===
                                            rTimeEntryTypeUnbillable_Id
                                        )?.Name,
                                    }
                              }
                              onChange={(e) => {
                                dispatch(
                                  timerTimeRecordTypeUnbillableId(e?.id)
                                );
                                //on clear set to empty
                                if (isEmpty(e)) {
                                  dispatch(timerTimeRecordTypeUnbillableId(""));
                                }
                                handleServerTimeEntrySingleEntryUpdate();
                              }}
                              options={
                                !isEmpty(timeEntryTypeList)
                                  ? timeEntryTypeList?.map((item) => ({
                                      label: "#" + item.Id + ", " + item?.Name,
                                      value: item.Id,
                                      id: item.Id,
                                    }))
                                  : []
                              }
                              id="non-billable-select"
                            ></Select>
                            <Select
                              isClearable
                              className="mb-2 job-select3 "
                              placeholder={
                                "Allocate to Opportunity (optional)..."
                              }
                              value={
                                isEmpty(rOpportunity_Id)
                                  ? null
                                  : {
                                      value: rOpportunity_Id,
                                      label:
                                        "#" +
                                        rOpportunity_Id +
                                        ", " +
                                        (opportunityList?.find(
                                          (item) => item.Id === rOpportunity_Id
                                        )?.Title ??
                                          timeEntryData?.timeentry_data
                                            ?.Opportunity_Title ??
                                          ""),
                                    }
                              }
                              onChange={(e) => handleSelectOpportunity(e)}
                              options={(opportunityList ?? [])
                                .filter(
                                  (item) =>
                                    item?.OpportunityStatus_FlagActive != "0" ||
                                    item.Id === rOpportunity_Id
                                )
                                .map((item) => ({
                                  label:
                                    "#" +
                                    item.Id +
                                    ", " +
                                    item?.Title +
                                    (item?.Customer_FullName
                                      ? " (" + item.Customer_FullName + ")"
                                      : ""),
                                  value: item.Id,
                                  title: item?.Title,
                                  customer: item?.Customer_FullName,
                                }))}
                              id="non-billable-opportunity-select"
                            ></Select>
                          </div>
                        )}
                      </div>
                    )}
                  </div>

                  <>
                    <div className={"d-flex align-items-center select-job-1"}>
                      <div
                        className={"d-flex align-items-center p-2"}
                        style={{ width: "60px" }}
                      >
                        <span>Start</span>
                      </div>
                      <div
                        className={
                          "d-flex align-items-center flex-wrap p-2 flex-grow-1"
                        }
                        style={{ minWidth: 0, gap: "6px" }}
                      >
                        <Flatpickr
                          onOpen={() => {
                            setOnCalendarOpen(true);
                          }}
                          onClose={() => {
                            setOnCalendarOpen(false);
                            setIsNotificationDropdown(true);
                          }}
                          className={
                            "form-control start-finish-time-tracking-input"
                          }
                          style={{
                            flex: "1 1 120px",
                            minWidth: 0,
                            width: "auto",
                          }}
                          options={{
                            enableTime: true,
                            dateFormat: "Y-m-d H:i",
                            // defaultDate: timeFormatDateAndTimeNoSeconds(
                            //   new Date()[0]
                            // ),
                          }}
                          value={
                            rTimeEntryStartDateTime === "today"
                              ? timeFormatDateAndTimeNoSeconds(new Date()[0])
                              : rTimeEntryStartDateTime
                          }
                          onChange={(date) => {
                            dispatch(
                              timerTimeEntryStartDateTime(
                                timeFormatDateAndTime(date[0])
                              )
                            );
                            handleServerTimeEntrySingleEntryUpdate();
                          }}
                        />
                        <span
                          className={
                            "btn btn-soft-primary btn-sm flex-shrink-0"
                          }
                          title={"Set Start to the current time"}
                          onClick={() => {
                            dispatch(
                              timerTimeEntryStartDateTime(
                                timeFormatDateAndTime(new Date())
                              )
                            );
                            handleServerTimeEntrySingleEntryUpdate();
                          }}
                        >
                          Now
                        </span>
                      </div>
                    </div>
                    {rtimerIsRunning ? (
                      <div
                        className={"d-flex align-items-center  select-job-1"}
                      >
                        <div
                          className={"d-flex align-items-center p-2"}
                          style={{ width: "60px" }}
                        >
                          <span className={"me-2"}>End</span>
                        </div>
                        <div
                          className={
                            "d-flex align-items-center flex-wrap p-2 flex-grow-1"
                          }
                          style={{ minWidth: 0, gap: "6px" }}
                        >
                          <Flatpickr
                            onOpen={() => {
                              setOnCalendarOpen(true);
                              // set with todays date and time
                              dispatch(
                                timerTimeEntryEndDateTime(
                                  // we only want to dispatch new date if there is no end date time set already otherwise it will update to current date and time on every open
                                  isEmpty(rTimeEntryEndDateTime)
                                    ? timeFormatDateAndTime(
                                        defaultEndDateTime()
                                      )
                                    : rTimeEntryEndDateTime
                                )
                              );
                            }}
                            onClose={() => {
                              setOnCalendarOpen(false);
                              setIsNotificationDropdown(true);
                            }}
                            className={
                              "form-control " +
                              (rTimeEntryEndDateTime
                                ? " finish-time-tracking-input"
                                : "start-finish-time-tracking-input")
                            }
                            style={{
                              flex: "1 1 120px",
                              minWidth: 0,
                              width: "auto",
                            }}
                            options={{
                              enableTime: true,
                              dateFormat: "Y-m-d H:i",
                              defaultDate: [rTimeEntryEndDateTime],
                            }}
                            value={rTimeEntryEndDateTime}
                            onChange={(date) => {
                              dispatch(
                                timerTimeEntryEndDateTime(
                                  timeFormatDateAndTime(date[0])
                                )
                              );
                              handleServerTimeEntrySingleEntryUpdate();
                            }}
                          />
                          <span
                            className={
                              "btn btn-soft-primary btn-sm flex-shrink-0"
                            }
                            title={"Set End to the current time"}
                            onClick={() => {
                              dispatch(
                                timerTimeEntryEndDateTime(
                                  timeFormatDateAndTime(new Date())
                                )
                              );
                              handleServerTimeEntrySingleEntryUpdate();
                            }}
                          >
                            Now
                          </span>
                          {rTimeEntryEndDateTime && (
                            <div className={"flex-shrink-0"}>
                              <span
                                className={"btn btn btn-danger btn-sm"}
                                title={"Clear End time"}
                                onClick={() => {
                                  dispatch(timerTimeEntryEndDateTime(""));
                                  handleServerTimeEntrySingleEntryUpdate();
                                }}
                              >
                                <i className="fa-regular fa-calendar-xmark"></i>
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                    ) : null}
                  </>

                  <VoiceToTextAI popupTimer={true} />
                  {/*<hr />*/}
                  {/*<h5 className={"text-center"}>Timer Options</h5>*/}
                  <div
                    className={
                      "d-flex align-items-center justify-content-center select-job-1 p-2"
                    }
                  >
                    {!rtimerIsRunning ? (
                      <div className={"p-1"}>
                        <button
                          style={{ width: "95px" }}
                          className={"btn btn-primary"}
                          onClick={() => {
                            handleStartTimer();
                          }}
                        >
                          Start
                        </button>
                      </div>
                    ) : null}
                    {rtimerIsRunning ? (
                      <div>
                        <button
                          style={{ width: "95px" }}
                          className={"btn btn-danger"}
                          onClick={() => {
                            handleStopTimer();
                            setStopStartTimer("stop");
                          }}
                        >
                          Stop
                        </button>
                      </div>
                    ) : null}

                    {rtimerIsRunning ? (
                      <div className={"p-1"}>
                        <button
                          style={{ width: "95px" }}
                          className={"btn btn-success"}
                          onClick={() => {
                            // If chaining from the previous End time is enabled and an
                            // End time is set, remember it so the next timer starts there
                            // instead of "now" (useful when backdating entries).
                            stopStartNextStartRef.current =
                              chainStartFromPrevEnd &&
                              !isEmpty(rTimeEntryEndDateTime)
                                ? rTimeEntryEndDateTime
                                : null;
                            handleStopTimer();
                            setStopStartTimer("stopStart");
                          }}
                        >
                          Stop Start
                        </button>
                      </div>
                    ) : null}
                  </div>
                  {rtimerIsRunning ? (
                    <div className="text-center">
                      <button
                        type="button"
                        className="btn btn-link btn-sm text-danger p-0"
                        title="Discard this timer without logging any time"
                        onClick={() => setModalVoidTimer(true)}
                      >
                        <i className="ri-delete-bin-line align-bottom me-1" />
                        Void timer
                      </button>
                    </div>
                  ) : null}
                </div>
                {/* Secret / subtle extra options drawer */}
                <div className="timer-extras-wrapper">
                  {/* Chariot / handle button */}
                  <div className="d-flex justify-content-center">
                    <button
                      id="timerExtrasToggle"
                      type="button"
                      className={classnames("timer-extras-toggle", {
                        "is-open": isExtrasOpen,
                      })}
                      onClick={() => setIsExtrasOpen((prev) => !prev)}
                    >
                      <i
                        className={
                          isExtrasOpen
                            ? "fa-solid fa-chevron-up"
                            : "fa-solid fa-chevron-down"
                        }
                      />
                    </button>
                  </div>

                  {/* Hover helper */}
                  <Tooltip
                    placement="top"
                    isOpen={extrasTooltipOpen}
                    target="timerExtrasToggle"
                    toggle={() => setExtrasTooltipOpen((v) => !v)}
                  >
                    Additional Options
                  </Tooltip>

                  {/* Collapsible content area */}
                  <Collapse isOpen={isExtrasOpen}>
                    <div className="timer-extras-inner">
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <span className="fw-semibold">Additional Options</span>
                      </div>

                      <div className="form-check mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="chainStartFromPrevEnd"
                          checked={chainStartFromPrevEnd}
                          onChange={(e) => {
                            const checked = e.target.checked;
                            setChainStartFromPrevEnd(checked);
                            localStorage.setItem(
                              "timerChainStartFromPrevEnd",
                              checked ? "1" : "0"
                            );
                          }}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="chainStartFromPrevEnd"
                          title="When you use Stop Start, begin the new timer at this timer's End time instead of the current time. Useful when backdating entries."
                        >
                          Start next timer from this End time
                        </label>
                      </div>

                      <button
                        type="button"
                        className="btn btn-outline-primary w-100 mb-2"
                        onClick={handleAddMultipleTimers}
                      >
                        <i className="fa-solid fa-layer-group me-2" />
                        Add Multiple Timers
                      </button>

                      <Link
                        to="/recently-viewed"
                        className="btn btn-outline-primary w-100 mb-2"
                        onClick={toggleNotificationDropdown}
                      >
                        <i className="fa-solid fa-clock-rotate-left me-2" />
                        Recently Viewed
                      </Link>

                      {/* Future extra actions can go here */}
                      {/* <button className="btn btn-outline-secondary w-100">Something else</button> */}
                      {modalMultipleTimeEntries && (
                        <AddMultipleTimeEntries
                          modal={modalMultipleTimeEntries}
                          setModal={setModalMultipleTimeEntries}
                          toggle={toggleModalMultipleTimeEntries}
                        />
                      )}
                    </div>
                  </Collapse>
                </div>
              </TabPane>
              <TabPane tabId="2" className="py-2 ps-2">
                {/*Today Tab*/}
                <SimpleBar style={{ maxHeight: "70vh" }} className="pe-2">
                  <div className="">
                    {!isEmpty(todaysTimeEntries) && (
                      <div>
                        <Card>
                          <div className="d-flex mt-0 p-2 ">
                            <div className={""}>
                              <h6 className="mt-0 mb-1 fs-13 fw-semibold">
                                Time Summary
                              </h6>
                              <div>
                                <div>
                                  <span className={"fw-semibold"}>
                                    Total Time:{" "}
                                  </span>
                                  <span className={"fw-semibold"}>
                                    {/*using moment method and diff Caulculate all*/}
                                    {/*time entries time in hours and float as minutes using*/}
                                    {/*Properties TimeEntryStartDateTime for start*/}
                                    {/*and TimeEntryEndDateTime for end if TimeEntryEndDateTime is null use current time*/}
                                    {todaysTimeEntries
                                      ?.map((item) => {
                                        if (item.TimeEntryEndDateTime) {
                                          return moment(
                                            item.TimeEntryEndDateTime
                                          ).diff(
                                            moment(item.TimeEntryStartDateTime),
                                            "minutes"
                                          );
                                        } else {
                                          return moment().diff(
                                            moment(item.TimeEntryStartDateTime),
                                            "minutes"
                                          );
                                        }
                                      }) // get hour or hours and no minutes
                                      .reduce((a, b) => a + b, 0) /
                                      60 >=
                                    1
                                      ? Math.floor(
                                          todaysTimeEntries
                                            ?.map(
                                              (item) => {
                                                if (item.TimeEntryEndDateTime) {
                                                  return moment(
                                                    item.TimeEntryEndDateTime
                                                  ).diff(
                                                    moment(
                                                      item.TimeEntryStartDateTime
                                                    ),
                                                    "minutes"
                                                  );
                                                } else {
                                                  return moment().diff(
                                                    moment(
                                                      item.TimeEntryStartDateTime
                                                    ),
                                                    "minutes"
                                                  );
                                                }
                                              } // get hour or hours and no minutes
                                            )
                                            .reduce((a, b) => a + b, 0) / 60
                                        )
                                      : null}{" "}
                                    h {/*remainder convert to minutes*/}
                                    {todaysTimeEntries
                                      ?.map((item) => {
                                        if (item.TimeEntryEndDateTime) {
                                          return moment(
                                            item.TimeEntryEndDateTime
                                          ).diff(
                                            moment(item.TimeEntryStartDateTime),
                                            "minutes"
                                          );
                                        } else {
                                          return moment().diff(
                                            moment(item.TimeEntryStartDateTime),
                                            "minutes"
                                          );
                                        }
                                      })
                                      .reduce((a, b) => a + b, 0) % 60}{" "}
                                    m
                                  </span>
                                </div>
                              </div>
                              <div>
                                <div>
                                  <span className={"fw-semibold"}>
                                    Total Billable Time:{" "}
                                  </span>
                                  <span className={"fw-semibold"}>
                                    {/*using moment method and diff Calculate billable time only*/}
                                    {/*time entries time in hours and float as minutes using*/}
                                    {/*Properties TimeEntryStartDateTime for start*/}
                                    {/*and TimeEntryEndDateTime for end if TimeEntryEndDateTime is null use current time*/}
                                    {todaysTimeEntries
                                      ?.filter(
                                        (item) =>
                                          item.TimeEntryTypeUnbillable_Id ===
                                          null
                                      )
                                      ?.map((item) => {
                                        if (item.TimeEntryEndDateTime) {
                                          return moment(
                                            item.TimeEntryEndDateTime
                                          ).diff(
                                            moment(item.TimeEntryStartDateTime),
                                            "minutes"
                                          );
                                        } else {
                                          return moment().diff(
                                            moment(item.TimeEntryStartDateTime),
                                            "minutes"
                                          );
                                        }
                                      }) // get hour or hours and no minutes
                                      .reduce((a, b) => a + b, 0) /
                                      60 >=
                                    1
                                      ? Math.floor(
                                          todaysTimeEntries
                                            ?.filter(
                                              (item) =>
                                                item.TimeEntryTypeUnbillable_Id ===
                                                null
                                            )
                                            ?.map(
                                              (item) => {
                                                if (item.TimeEntryEndDateTime) {
                                                  return moment(
                                                    item.TimeEntryEndDateTime
                                                  ).diff(
                                                    moment(
                                                      item.TimeEntryStartDateTime
                                                    ),
                                                    "minutes"
                                                  );
                                                } else {
                                                  return moment().diff(
                                                    moment(
                                                      item.TimeEntryStartDateTime
                                                    ),
                                                    "minutes"
                                                  );
                                                }
                                              } // get hour or hours and no minutes
                                            )
                                            .reduce((a, b) => a + b, 0) / 60
                                        )
                                      : null}{" "}
                                    h {/*remainder convert to minutes*/}
                                    {todaysTimeEntries
                                      ?.filter(
                                        (item) =>
                                          item.TimeEntryTypeUnbillable_Id ===
                                          null
                                      )
                                      ?.map((item) => {
                                        if (item.TimeEntryEndDateTime) {
                                          return moment(
                                            item.TimeEntryEndDateTime
                                          ).diff(
                                            moment(item.TimeEntryStartDateTime),
                                            "minutes"
                                          );
                                        } else {
                                          return moment().diff(
                                            moment(item.TimeEntryStartDateTime),
                                            "minutes"
                                          );
                                        }
                                      })
                                      .reduce((a, b) => a + b, 0) % 60}{" "}
                                    m
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Card>
                      </div>
                    )}
                    {!isEmpty(todaysTimeEntries) ? (
                      <>
                        {todaysTimeEntries.map((timeEntry, index) => {
                          return (
                            <Card key={index} className={"btn-soft-light mb-2"}>
                              {/*{timeEntry?.FlagOpen === "1" && (*/}
                              {/*  <div>*/}
                              {/*    <span className=" badge bg-soft-success text-success ms-2">*/}
                              {/*      Timer On - Live*/}
                              {/*    </span>*/}
                              {/*  </div>*/}
                              {/*)}*/}
                              {timeEntry?.FlagOpen === "0" && (
                                <div className="d-flex mt-0 p-2">
                                  <div className="flex-1">
                                    <h6 className="mt-0 mb-1 fs-13 fw-semibold">
                                      {timeEntry.Job_Id && (
                                        <>
                                          <Link
                                            to={`/single-job/${timeEntry.Job_Id}`}
                                          >
                                            {timeEntry?.Job_Title}
                                          </Link>
                                        </>
                                      )}
                                      {timeEntry?.TimeEntryTypeUnbillable_Id &&
                                        timeEntry?.TimeEntryTypeUnbillable_Name}
                                      {timeEntry?.Opportunity_Id && (
                                        <Link
                                          to={`/opportunity/${timeEntry.Opportunity_Id}/view`}
                                          className="ms-1"
                                        >
                                          {timeEntry?.TimeEntryTypeUnbillable_Id
                                            ? "- "
                                            : ""}
                                          {timeEntry?.Opportunity_Title}
                                        </Link>
                                      )}
                                    </h6>
                                    {timeEntry?.Customer_FullName && (
                                      <Link
                                        to={`/customer-single/${timeEntry?.Customer_Id}/view`}
                                        className={"my-2"}
                                      >
                                        <span
                                          className={"badge badge-soft-info"}
                                        >
                                          {timeEntry?.Customer_FullName}
                                        </span>
                                      </Link>
                                    )}

                                    <div className="fs-13 text-muted">
                                      <p className="mb-1">
                                        {timeEntry?.Notes
                                          ? timeEntry?.Notes
                                          : "No Notes"}
                                      </p>
                                    </div>
                                    {timeEntry?.TimeEntryEndDateTime !==
                                    "0000-00-00 00:00:00" ? (
                                      <div>
                                        <p className="mb-0 fs-11 fw-medium text-uppercase text-muted">
                                          <span>
                                            Start time{" "}
                                            {timeEntry?.TimeEntryStartDateTime}
                                          </span>
                                        </p>
                                        <p className="mb-0 fs-11 fw-medium text-uppercase text-muted">
                                          <span>
                                            End time{" "}
                                            {timeEntry?.TimeEntryEndDateTime}
                                          </span>
                                        </p>
                                        <p className="mb-0 fs-11 fw-medium text-uppercase text-muted">
                                          <span>
                                            <i className="mdi mdi-clock-outline"></i>{" "}
                                            {convertMinsToHrsMins(
                                              timeEntry?.DurationMins
                                            )}
                                          </span>
                                        </p>
                                      </div>
                                    ) : (
                                      <div>
                                        <p className="mb-0 fs-11 fw-medium text-uppercase text-muted">
                                          <span>
                                            Start time{" "}
                                            {timeEntry?.TimeEntryStartDateTime}
                                          </span>
                                        </p>
                                        <p className="mb-0 fs-11 fw-medium text-uppercase text-muted">
                                          <span>Timer is Live</span>
                                        </p>
                                      </div>
                                    )}
                                  </div>
                                  <div
                                    className="edit-time-entry-action-icon  fs-15"
                                    title={"Edit Time Entry Coming Soon"}
                                  >
                                    {/*<div className="form-check notification-check">*/}
                                    {/*  <i className="fa-solid fa-pen-to-square"></i>*/}
                                    {/*</div>{" "}*/}
                                    {timeEntry.BillableType === "1" && (
                                      <div
                                        title={`Open Job ${timeEntry?.Job_Id}`}
                                      >
                                        {rJob_Id && (
                                          <Link
                                            to={`/single-job/${timeEntry?.Job_Id}`}
                                          >
                                            <div
                                              className={
                                                "text-primary fs-8 m-0"
                                              }
                                            >
                                              <i className="fa-solid fa-link"></i>
                                            </div>
                                          </Link>
                                        )}
                                      </div>
                                    )}
                                  </div>

                                  <div
                                    onClick={() => {
                                      handleAssignTimeEntryToTimer(timeEntry);
                                    }}
                                    className={"loop-select-data-and-assign"}
                                    title={
                                      "Assign this Job to your current Timer"
                                    }
                                  >
                                    <div>
                                      <i className="fa-solid fa-clock-rotate-left fs-15"></i>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </Card>
                          );
                        })}
                      </>
                    ) : (
                      <div className="text-center">
                        <span>
                          <i className="mdi mdi-clock-outline"></i> No Time
                          Entries
                        </span>
                      </div>
                    )}
                    <div>
                      <div className="text-center">
                        <Link
                          className={"btn btn-soft-success"}
                          to={`/time-entries`}
                        >
                          <span>View All</span>
                        </Link>
                      </div>
                    </div>
                  </div>
                </SimpleBar>
              </TabPane>
              <TabPane tabId="3" className="p-4">
                <div className="w-25 w-sm-50 pt-3 mx-auto">
                  <img src={bell} className="img-fluid" alt="user-pic" />
                </div>
                <div className="text-center pb-5 mt-2">
                  <h6 className="fs-18 fw-semibold lh-base">
                    Hey! You have no any notifications{" "}
                  </h6>
                </div>
              </TabPane>
            </TabContent>
          )}
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

export default TimeTrackingDropdown;
